var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* tslint:disable */
import { NetworkError } from "../Errors/NetworkError";
import fetchWithTimeout from "../utils/FetchWithTimeout";
export class APIWrapper {
    constructor() {
        //private baseAPIURL = "https://jeffpi.fews.jbahosting.com/FewsWebServices/rest/fewspiservice/v1/timeseries";
        this.baseAPIURL = "https://leepi.fews.jbahosting.com/FewsWebServices/rest/fewspiservice/v1/timeseries";
    }
    submitRequest(request) {
        return __awaiter(this, void 0, void 0, function* () {
            let response;
            try {
                response = (yield fetchWithTimeout(request));
            }
            catch (err) {
                throw err;
            }
            if (response.ok) {
                return response;
            }
            else {
                throw new Error(`Bad response code: ${response.status}`);
            }
        });
    }
    getRainfallData() {
        return __awaiter(this, void 0, void 0, function* () {
            let responseArray = [];
            let requestArray = [];
            if (this.cachedForecastRainfallData === undefined) {
            }
            else {
                responseArray[1] = this.cachedForecastRainfallData;
            }
            if (this.cachedForecastRainfallData === undefined) {
            }
            else {
                responseArray[0] = this.cachedForecastRainfallData;
            }
            responseArray = yield Promise.all(requestArray);
            if (requestArray.length === 0) {
                return Promise.resolve(responseArray);
            }
            else {
                throw new Error("Not implemeneted");
            }
        });
    }
    submitFEWSRequest(fewsURL) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = fewsURL.buildURL(this.baseAPIURL);
            let request = new Request(url, { "method": "GET" });
            let apiResponse;
            try {
                let response = yield this.submitRequest(request);
                apiResponse = yield response.json();
                apiResponse.originalURL = url;
            }
            catch (e) {
                if (e instanceof NetworkError && e.message.toLowerCase() == 'timeout') {
                    let errorEvent = new CustomEvent("APIError", { detail: "API Call Timeout" });
                    document.dispatchEvent(errorEvent);
                }
                throw e;
            }
            apiResponse.summarySeries = fewsURL.summarySeries;
            return apiResponse;
        });
    }
}
